/**
 * Global ApexCharts typography — Rubik everywhere (axis labels, legend, tooltips).
 * Imported once from index.js before any chart mounts.
 */
import { RUBIK_FONT_FAMILY_APEX } from "./fontStack";

const FONT = RUBIK_FONT_FAMILY_APEX;

/** Vertical area fill that fades to transparent (Incoming Request Trends style). */
export function apexVerticalAreaGradient({
  toColor = "rgba(99, 113, 247, 0.25)",
  opacityFrom = 1,
  opacityTo = 0,
} = {}) {
  return {
    type: "gradient",
    gradient: {
      shade: "light",
      type: "vertical",
      shadeIntensity: 1,
      inverseColors: false,
      gradientToColors: [toColor],
      opacityFrom,
      opacityTo,
      stops: [0, 100],
    },
  };
}

/** Left Y-axis title in “No. of …” form (no X-axis title). */
export function apexNoOfYAxisTitle(text) {
  return {
    text,
    rotate: -90,
    offsetX: 0,
    style: {
      color: "#696969",
      fontSize: "12px",
      fontWeight: 500,
      fontFamily: FONT,
    },
  };
}

const APEX_RUBIK_DEFAULTS = {
  chart: {
    fontFamily: FONT,
  },
  legend: {
    fontFamily: FONT,
  },
  xaxis: {
    labels: {
      style: {
        fontFamily: FONT,
      },
    },
    title: {
      style: {
        fontFamily: FONT,
      },
    },
    // Hide the axis "tooltip" chip under the chart — it duplicates the
    // date already shown in the main series tooltip on hover.
    tooltip: {
      enabled: false,
    },
  },
  yaxis: {
    labels: {
      style: {
        fontFamily: FONT,
      },
    },
    title: {
      style: {
        fontFamily: FONT,
      },
    },
  },
  tooltip: {
    style: {
      fontFamily: FONT,
    },
  },
  title: {
    style: {
      fontFamily: FONT,
    },
  },
  subtitle: {
    style: {
      fontFamily: FONT,
    },
  },
  dataLabels: {
    style: {
      fontFamily: FONT,
    },
  },
  noData: {
    style: {
      fontFamily: FONT,
    },
  },
  plotOptions: {
    radialBar: {
      dataLabels: {
        name: {
          style: {
            fontFamily: FONT,
          },
        },
        value: {
          style: {
            fontFamily: FONT,
          },
        },
      },
    },
  },
};

function isPlainObject(value) {
  return value !== null && typeof value === "object" && !Array.isArray(value);
}

function deepMerge(base, patch) {
  const out = { ...base };
  Object.keys(patch).forEach((key) => {
    const patchVal = patch[key];
    const baseVal = base[key];
    if (isPlainObject(patchVal) && isPlainObject(baseVal)) {
      out[key] = deepMerge(baseVal, patchVal);
    } else {
      out[key] = patchVal;
    }
  });
  return out;
}

export function applyApexGlobalDefaults() {
  if (typeof window === "undefined") return;
  window.Apex = deepMerge(window.Apex || {}, APEX_RUBIK_DEFAULTS);
}

/** Merge Rubik defaults into per-chart options (for explicit overrides). */
export function withApexChartFont(options = {}) {
  return deepMerge(APEX_RUBIK_DEFAULTS, options);
}

applyApexGlobalDefaults();
